import * as React from "react"

export interface TextHeaderProps {
  title: string
}

export class TextHeader extends React.Component<TextHeaderProps> {
  render() {
    return (
      <div className="flex flex-col gap-4 relative overflow-visible">
        <h2 className="text-4xl font-black uppercase text-primary">
          {this.props.title}
        </h2>
        <span className="absolute text-primary text-7xl top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-5 whitespace-nowrap uppercase font-black">
          {this.props.title}
        </span>
      </div>
    )
  }
}
